import FormBase from "../FormBase";
import FormFieldBase from "../FormFieldBase";
import ValidationBase, { ValidationType } from "../ValidationBase";
import Professional from '../../models/Professional'
import OptionItem from "../../models/OptionItem";
import ProfessionalTeamService from "../../services/ProfessionalTeamService";
import ProfessionalTeam from "../../models/ProfssionalTeam";

export class ReRegistrationProfessionalTeamFormItem {
    Id: number;
    Team: string | undefined;
    TeamValue: any;
    Occupation: string | undefined;
    OccupationValue: any;
    Boss: string |  undefined;
    TasyCode: number | undefined;
    RemoveTasy: boolean | undefined;

    constructor(Id: number, Team: any, Occupation: any, Boss: string) {
        this.Id = Id;
        this.Team = Team.Text;
        this.TeamValue = Team;
        this.Occupation = Occupation.Text;
        this.OccupationValue = Occupation;
        this.Boss = Boss;
    }

    static NewInstance(): ReRegistrationProfessionalTeamFormItem {
        return new ReRegistrationProfessionalTeamFormItem(0, "", "", "");
    }

}

export default class ReRegistrationProfessionalTeamForm implements FormBase {

    Team: FormFieldBase;
    Occupation: FormFieldBase;
    FormItemList: ReRegistrationProfessionalTeamFormItem[];
    FormRemoveList: ReRegistrationProfessionalTeamFormItem[];
    FormItemToEdit: ReRegistrationProfessionalTeamFormItem;

    constructor(Team: string, Occupation: string, Establishment: string) {

        this.Team = new FormFieldBase(Team, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
        this.Occupation = new FormFieldBase(Occupation, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
        this.FormItemList = new Array<ReRegistrationProfessionalTeamFormItem>();
        this.FormRemoveList = new Array<ReRegistrationProfessionalTeamFormItem>();
        this.FormItemToEdit = ReRegistrationProfessionalTeamFormItem.NewInstance();
    }

    AddOrUpdateReRegistrationProfessionalTeamFormItem() {
        if (this.ValidateForm()) {

            //Insert
            if (this.FormItemToEdit === null || this.FormItemToEdit.Id === 0) {

                let item = ReRegistrationProfessionalTeamFormItem.NewInstance();
                item.Id = this.getNewId();
                item.Occupation = this.Occupation.Value.Text;
                item.OccupationValue = this.Occupation.Value;
                item.Team = this.Team.Value.Value.Description;
                item.TeamValue = this.Team.Value;
                item.Boss = this.Team.Value.Value.BossName;

                this.FormItemList.push(item);

                //Update    
            } else {
                for (let index = 0; index < this.FormItemList.length; index++) {
                    const element = this.FormItemList[index];
                    if (element.Id === this.FormItemToEdit.Id) {

                        let item = ReRegistrationProfessionalTeamFormItem.NewInstance();
                        item.Id = this.getNewId();
                        item.Occupation = this.Occupation.Value.Text;
                        item.OccupationValue = this.Occupation.Value;
                        item.Team = this.Team.Value.Value.Description;
                        item.TeamValue = this.Team.Value;
                        item.Boss = this.Team.Value.Value.BossName;

                        item.RemoveTasy = element.RemoveTasy;
                        item.TasyCode = element.TasyCode;

                        this.FormItemList[index] = item;
                    }
                }
            }
            this.ResetForm();
        }
    }

    CallInsertOrUpdateApi(Professional: Professional): Promise<boolean> {
        const dataJson = this.getJsonObjet();
        return ProfessionalTeamService.postInsertOrUpdateProfssionalTeam(dataJson, Professional.Id);
    }

    async PreloadFormFromApi(requestId: string): Promise<any> {

        
        return await ProfessionalTeamService.CreateAndGetProfssionalTeamFromTasy(requestId).then((data: ProfessionalTeam[]) => {

            this.FormItemList = new Array<ReRegistrationProfessionalTeamFormItem>();
            this.FormRemoveList = new Array<ReRegistrationProfessionalTeamFormItem>();

            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                let optionTeam: OptionItem | undefined = undefined;

                if (element.TeamName !== undefined && element.TeamTasyCode !== undefined) {
                    let teamValue = {
                        Description: element.TeamName,
                        BossName: element.BossName,
                        Id: element.TeamTasyCode
                    }
                    optionTeam = new OptionItem(element.TeamTasyCode, element.TeamName, teamValue);
                }

                let optionOccupation: OptionItem | undefined = undefined;

                if (element.OccupationName !== undefined && element.OccupationTasyCode !== undefined && element.OccupationTasyCode !== null) {
                    optionOccupation = new OptionItem(element.OccupationTasyCode, element.OccupationName, element.OccupationTasyCode.toString());
                }

                let item = ReRegistrationProfessionalTeamFormItem.NewInstance();
                item.Id = this.getNewId();
                item.Boss = element.BossName;
                item.Occupation = element.OccupationName;
                item.OccupationValue = optionOccupation;
                item.Team = element.TeamName;
                item.TeamValue = optionTeam;
                item.RemoveTasy = element.RemoveTasy;
                item.TasyCode = element.TasyCode;

                this.FormItemList.push(item);

            }

        });
    }

    EditReRegistrationProfessionalTeamFormItem(id: number) {
        this.ResetForm();

        for (let index = 0; index < this.FormItemList.length; index++) {
            const element = this.FormItemList[index];

            if (element.Id === id) {
                this.FormItemToEdit = element;
                this.Team.Value = this.FormItemToEdit.TeamValue;
                this.Occupation.Value = this.FormItemToEdit.OccupationValue;
            }
        }
    }

    RemoveReRegistrationProfessionalTeamFormItem(id: number) {
        for (let index = 0; index < this.FormItemList.length; index++) {
            const element = this.FormItemList[index];
            if (element.Id === id) {
                if (element.TasyCode === undefined || element.TasyCode === 0) {
                    this.FormItemList.splice(index, 1);
                } else {
                    element.RemoveTasy = true;
                    this.FormRemoveList.push(element);
                    this.FormItemList.splice(index, 1);
                }
            }
        }
    }


    static NewInstance(): ReRegistrationProfessionalTeamForm {
        return new ReRegistrationProfessionalTeamForm("", "", "");
    }

    ValidateForm(): boolean {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        return formIsValid;
    }


    ValidateToGoNextStep(): string {
        // if (this.FormItemList.length === 0) {
        //     return "Por favor, insira ao menos uma equipe."
        // }
        return "";
    }

    ResetForm(): void {
        let propNames = Object.getOwnPropertyNames(this);
        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            this.GetFieldByName(element).Value = "";
            this.GetFieldByName(element).Error = "";
        }

        this.FormItemToEdit = ReRegistrationProfessionalTeamFormItem.NewInstance();
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "Team":
                return this.Team;
            case "Occupation":
                return this.Occupation
            default:
                return new FormFieldBase("", []);
        }
    }


    getNewId(): number {
        if (this.FormItemList.length > 0) {
            let maxId = Math.max.apply(Math, this.FormItemList.map(function (o) { return o.Id; }))
            return maxId + 1;
        } else {
            return 1;
        }
    }


    getJsonObjet(professionalId: number = 0) {

        let viewModelList: any[] = [];

        if (this.FormItemList !== null && this.FormItemList.length > 0) {
            this.FormItemList.forEach((element: ReRegistrationProfessionalTeamFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "teamName": element.TeamValue.Text,
                    "bossName": element.Boss,
                    "teamTasyCode": element.TeamValue.Id,
                    "occupationTasyCode": element.OccupationValue?.Id,
                    "occupationName": element.OccupationValue?.Text,
                    "tasyCode": element.TasyCode,
                    "removeTasy": element.RemoveTasy,
                })
            });
        }

        if (this.FormRemoveList !== null && this.FormRemoveList.length > 0) {
            this.FormRemoveList.forEach((element: ReRegistrationProfessionalTeamFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "teamName": element.TeamValue.Text,
                    "bossName": element.Boss,
                    "teamTasyCode": element.TeamValue.Id,
                    "occupationTasyCode": element.OccupationValue?.Id,
                    "occupationName": element.OccupationValue?.Text,
                    "tasyCode": element.TasyCode,
                    "removeTasy": element.RemoveTasy,
                })
            });
        }

        return viewModelList;
    }
}